import axios from 'axios'
import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'
import { objectToSnakeCase } from '../utils'

const USER_EVENT_URL = `${API_BASE}user-events/`

export default class UserEventAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new UserEventAPI(cls)
  }

  /* Create a new user event. */
  create(userEvent) {
    const data = objectToSnakeCase(userEvent)
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(USER_EVENT_URL, data, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Create User Event API error' }))
  }

  employeeCodeVerificationAttempts() {
    const url = USER_EVENT_URL + 'verification-attempts/'
    const data = {}
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios.post(url, data, options).then(res => this.cls.fromAPI(res.data))
  }

  requestStartBlocked() {
    const url = USER_EVENT_URL + 'request-start-blocked/'
    const data = {}
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios.post(url, data, options).then(res => this.cls.fromAPI(res.data))
  }
}
